import type { Dispatch, SetStateAction } from 'react';
import type { PipelineStepId, PipelineStepState } from '../types';

export function createStepStreamHandlers(
  stepId: PipelineStepId,
  setSteps: Dispatch<SetStateAction<Record<PipelineStepId, PipelineStepState>>>,
) {
  return {
    onStart: (total: number) => {
      setSteps((current) => ({
        ...current,
        [stepId]: {
          ...current[stepId],
          streamTotal: total,
          streamProgress: null,
          streamItems: [],
          streamMode: 'live',
          output: stepId === 'lin' ? [] : null,
        },
      }));
    },
    onProgress: (progress: {
      index: number;
      total: number;
      logId?: string;
    }) => {
      setSteps((current) => ({
        ...current,
        [stepId]: {
          ...current[stepId],
          streamProgress: progress,
        },
      }));
    },
    onItem: (item: {
      index: number;
      total: number;
      logId?: string;
      partIndex?: number;
      partTotal?: number;
      output: unknown;
      error?: string;
    }) => {
      setSteps((current) => {
        const streamItem = {
          index: item.index,
          total: item.total,
          logId: item.logId,
          partIndex: item.partIndex,
          partTotal: item.partTotal,
          output: item.output,
          error: item.error,
          receivedAt: Date.now(),
        };
        const streamItems = [
          ...(current[stepId].streamItems ?? []),
          streamItem,
        ];
        const partialOutput =
          stepId === 'lin'
            ? streamItems.map((entry) => entry.output)
            : item.output;

        return {
          ...current,
          [stepId]: {
            ...current[stepId],
            streamItems,
            output: partialOutput,
          },
        };
      });
    },
    onComplete: (result: { total: number; output: unknown }) => {
      setSteps((current) => ({
        ...current,
        [stepId]: {
          ...current[stepId],
          streamTotal: result.total,
          streamProgress: null,
          output: result.output,
        },
      }));
    },
  };
}
